export const GET_TAG_NODES_START = 'GET_TAG_NODES_START';
export const GET_TAG_NODES_SUCCESS = 'GET_TAG_NODES_SUCCESS';
export const GET_TAG_NODES_FAIL = 'GET_TAG_NODES_FAIL';
